import { z } from 'zod';
import { isObjectEmpty } from '@utils/common';
import { addIssue } from './add-issue';

export const checkHasAtLeastOneValue = (obj: Record<string, any> | undefined) => {
  if (!obj) return false;

  if (Array.isArray(obj)) {
    return obj.some((value) => value !== null && value !== undefined && value > 0);
  }

  return Object.values(obj).some((value) => value !== null && value !== undefined && value > 0);
};

const MONTH_KEYS = Array.from({ length: 12 }, (_, index) => `month${index + 1}`);

const addMonthlyIssues = (
  field: string,
  basePath: Array<string | number>,
  ctx: {
    addIssue: (issue: z.IssueData) => void;
  },
) => {
  MONTH_KEYS.forEach((monthKey) => {
    addIssue(ctx, [...basePath, field, monthKey], 'Informe o consumo');
  });
};

export const validateConsumptionMonthly = (
  consumption: Record<string, any>,
  field: string,
  basePath: Array<string | number>,
  ctx: {
    addIssue: (issue: z.IssueData) => void;
  },
): boolean => {
  const shouldAddIssues = !consumption || isObjectEmpty(consumption) || !checkHasAtLeastOneValue(consumption);

  if (shouldAddIssues) {
    addMonthlyIssues(field, basePath, ctx);
    return false;
  }

  return true;
};
